<template>
    <div class="cart">

            <div class="panel panel-primary">
                <div class="panel-heading">
                    Your Basket
                </div>

                <div class="panel-body" v-if="!products.length">
                    <p>
                        <i>Your basket is empty!</i>
                    </p>
                </div>

                <div v-if="products.length">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Quantity</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(product, index) in products">
                            <td>
                                {{ product.name }}
                                <template v-for="variant in product.selectedVariants">
                                    <br> <strong>{{ variant.label }}:</strong> {{ variant.value }}
                                </template>
                                <template v-if="product.personalisation">
                                    <br /><strong>Pesonalisation:</strong> {{ product.personalisation }}
                                </template>
                            </td>
                            <td>
                                {{ product.quantity }}
                                <a href="#" @click.prevent="addToCart(product)"><i class="glyphicon glyphicon-plus-sign success"></i></a>
                                <a href="#" @click.prevent="removeFromCart(index)"><i class="glyphicon glyphicon-trash danger"></i></a>
                            </td>
                            <td>{{ product.price | currency }}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><b>Total:</b></td>
                                <td></td>
                                <td><b>{{ total | currency }}</b></td>
                            </tr>
                        </tfoot>
                    </table>
                    <div class="panel-footer">

                    <a href="/orders/new" class="btn btn-success pull-right">Check Out</a>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                products: 'cart/all'
            }),

            total() {
                return this.products.reduce((total, p) => {
                    return total + p.price * p.quantity;
                }, 0);
            }
        },

        methods: {
            ...mapActions({
                getCart: 'cart/all',
                addToCart: 'cart/addToCart',
                removeFromCart: 'cart/removeFromCart'
            })
        },

        mounted () {
            this.getCart();
        }
    }
</script>

<style scoped>
    .danger {
        color: #d9534f;
    }

    .success {
        color: #5cb85c;
    }

    th:last-child {
        width: 1px;
    }
</style>
